import { useState } from "react";
import classNames from "classnames";
import { TextField, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function Password({
  input: { onChange, value, onBlur, onFocus, name },
  meta: { touched, error } = {},
  disabled,
  fullWidth,
  alwaysShowEye = false,
  placeholder,
  inputProps,
  style, // eslint-disable-line no-unused-vars
  ...rest // eslint-disable-line no-unused-vars
}) {
  const [show, setShow] = useState(false);
  const hasError = touched && !!error;

  return (
    <div
      className={classNames("datetimeControl", {
        "datetimeControl--fullWidth": fullWidth,
      })}
    >
      <div
        className={classNames(
          "croField",
          { "croField--error": hasError },
          "container",
        )}
      >
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          type={show ? "text" : "password"}
          disabled={disabled}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur && onBlur(e.target.value)}
          onFocus={onFocus}
          placeholder={placeholder}
          inputProps={inputProps}
          name={name}
          error={hasError}
          helperText={hasError ? error : undefined}
        />
        {(!disabled || alwaysShowEye) &&
          (show ? (
            <IconButton
              className="eye-icon"
              onClick={() => setShow(false)}
              aria-label="Skrýt heslo"
              size="small"
            >
              <VisibilityOffIcon />
            </IconButton>
          ) : (
            <IconButton
              className="eye-icon"
              onClick={() => setShow(true)}
              aria-label="Zobrazit heslo"
              size="small"
            >
              <VisibilityIcon />
            </IconButton>
          ))}
      </div>
    </div>
  );
}
